import { render, staticRenderFns } from "./ReporteIngresosTotales.vue?vue&type=template&id=a6d536c2"
import script from "./ReporteIngresosTotales.vue?vue&type=script&lang=js"
export * from "./ReporteIngresosTotales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports